import { RootState } from "integrations/redux"
import { PanelModes, PanelNames } from "panels/constants"
import { PanelModeMap } from "./types"

export const root = (state: RootState) => state.panels

export const selectPanelModeByName =
    (name: PanelNames) =>
    (state: RootState): PanelModes =>
        root(state).mode[name]

export const selectPanelsModeMap = (state: RootState): PanelModeMap => root(state).mode
export const selectSuspenseMemory = (state: RootState): PanelModeMap | undefined =>
    root(state).suspenseMemory
